var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline-block" } },
    [
      _vm._t("default", [
        _vm.hasCancellableItems() &&
        (_vm.$store.state.Auth.userProperties.user_id ===
          this.travel_service.created_by_id ||
          _vm.$store.getters.hasPermission("travelOrder"))
          ? _c(
              "v-tooltip",
              {
                attrs: { bottom: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                attrs: { icon: "" },
                                on: {
                                  click: function($event) {
                                    _vm.dialog = true
                                  }
                                }
                              },
                              on
                            ),
                            [_c("v-icon", [_vm._v("fa-ban")])],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2470268774
                )
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("travelService.cancelBooking")) + " "
                )
              ]
            )
          : _vm._e()
      ]),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c("v-col", { staticClass: "px-0", attrs: { cols: "12" } }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(_vm.$t("travelService.cancellationDialogTitle"))
                      )
                    ])
                  ]),
                  _vm.loading
                    ? _c(
                        "v-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { cols: "12" }
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              color: "primary",
                              size: "105"
                            }
                          }),
                          _c("h3", { staticClass: "mt-4" }, [
                            _vm._v(_vm._s(_vm.$t("global.loading")))
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._l(_vm.cancelableTravelServices, function(
                    cancelableTravelService
                  ) {
                    return _c(
                      "v-row",
                      { key: cancelableTravelService.id, staticClass: "my-3" },
                      [
                        _c(
                          "div",
                          { staticStyle: { "max-width": "50px" } },
                          [
                            _c("v-checkbox", {
                              staticClass: "mx-2 mt-0",
                              attrs: {
                                value: cancelableTravelService.id,
                                "hide-details": ""
                              },
                              model: {
                                value: _vm.idServicesToCancel,
                                callback: function($$v) {
                                  _vm.idServicesToCancel = $$v
                                },
                                expression: "idServicesToCancel"
                              }
                            })
                          ],
                          1
                        ),
                        _c("travel-service-order-item-chip", {
                          staticClass: "my-0 py-0",
                          attrs: {
                            "travel-service-order-item": cancelableTravelService
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c("v-alert", { attrs: { outlined: "", type: "info" } }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("travelService.cancellationAlert")) +
                        " "
                    )
                  ])
                ],
                2
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled:
                          _vm.idServicesToCancel.length === 0 ||
                          _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }